import { observer } from 'mobx-react';
import CreateShareUrlStore from '../CreateShareUrlStore';
import ShareUrlBanner from './ShareUrlBanner';
import { emptyFragment } from '../../../../../../EmptyFragment';

interface Props {
  store: CreateShareUrlStore;
  possibleShareUrlCount: number;
}

function ShareUrlBannerState({ possibleShareUrlCount, store }: Props) {
  switch (store.state.kind) {
    case 'ready':
      return (
        <ShareUrlBanner creating={store.creating} possibleShareUrlCount={possibleShareUrlCount} />
      );
    case 'waiting':
    case 'creating':
    case 'error':
      return emptyFragment();
  }
}

export default observer(ShareUrlBannerState);
